<template>
    <div id="app">
        <!-- <v-app id="inspire"> -->
        <v-card v-model="show">
            <v-toolbar dark color="green">
                <v-toolbar-title>Calendario de Calibraciones / Ensayos</v-toolbar-title>
            </v-toolbar>
        </v-card>

        <Calendar language="es" render-style="background" allow-overlap="true" @mouse-on-day="mouseOnDay"
            @mouse-out-day="mouseOutDay" :data-source="dataSource"></Calendar>

        <!-- </v-app> -->
    </div>
</template>
<style scoped>
body {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: smaller;
}
</style>
<script>
import axios from "../../../../src/axios-auth";
import Calendar from 'v-year-calendar';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'v-year-calendar/locales/v-year-calendar.es';
import 'js-year-calendar/dist/js-year-calendar.css';

export default {
    components: {
        Calendar
    },
    data: (vm) => ({
        tooltip: null,
        valid: false,
        lazy: false,
        dataSource: [],
        flag: true,
    }),
    computed: {
        show: {
            get() {
                if (this.flag == true) {
                    this.cargarCalendario();
                    console.log(this.dataSource)
                    this.flag = false;
                }
                // this.responsable = this.$store.state.nombre.toString().trim();
            },
            set(value) {
                if (!value) {
                    //this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {


        mouseOnDay: function (e) {
            if (e.events.length > 0) {
                var content = '';

                for (var i in e.events) {
                    content = content + '<div class="event-tooltip-content">'
                        + '<div class="event-name" style="color:' + e.events[i].color + '">' + e.events[i].codgral + '</div>'
                        + '<div class="event-details">' + e.events[i].detalle + '</div>'
                        + '</div>';
                    //content = "prueba";
                }

                if (this.tooltip != null) {
                    this.tooltip.destroy();
                    this.tooltip = null;
                }

                this.tooltip = tippy(e.element, {
                    placement: 'right',
                    content: content,
                    //animateFill: false,
                    animation: 'shift-away',
                    arrow: true,
                    allowHTML: true,
                });
                this.tooltip.show();
            }
        },
        mouseOutDay: function () {
            if (this.tooltip !== null) {
                this.tooltip.destroy();
                this.tooltip = null;
            }
        },

        cargarCalendario() {

            let self = this;
            axios
                .get("/SSGG/ProxCalib?")
                .then((response) => {
                    console.log("data" + response.data)
                    response.data.forEach(element => {
                        self.dataSource.push({
                            startDate: new Date(element.startDate),
                            endDate: new Date(element.endDate),
                            codgral: element.codgral,
                            detalle: element.detalle,
                        })
                    })
                })
                .catch((error) => {
                    self.dataSource = [];
                    console.log(error);
                });
        }
    }

}

</script>